<div class="my-4 p-3 text-white rounded-md flex items-start" [ngClass]="{
  'bg-green-500': type === 'success',
  'bg-red-500': type === 'danger',
  'bg-yellow-500': type === 'warning',
  'bg-blue-500': type === 'info',
}" role="alert">
  @if (icon) {
    <div class="flex items-center self-stretch shrink-0">
      <i class="h-4 w-4 me-3 text-base mr-1 border-white" [innerHTML]="icon | feather: { width: iconSize, height: iconSize }"></i>
    </div>
  }
  <div class="flex-1 leading-tight">
    <ng-content></ng-content>
  </div>
</div>
